import { db } from '../firebase';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';

const getImageList = async (collectionName) => {
  const q = query(collection(db, collectionName), orderBy('order', 'asc'));
  const snap = await getDocs(q);
  return snap.docs.map(d => d.data().image);
};

export const getBridalImages    = () => getImageList('bridal_images');
export const getPartyImages     = () => getImageList('party_images');
export const getEditorialImages = () => getImageList('editorial_images');
export const getGroomImages     = () => getImageList('groom_images');
export const getCourseImages    = () => getImageList('course_images');
export const getTutorialVideos = async () => {
  const q = query(collection(db, 'tutorial_videos'), orderBy('order', 'asc'));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ title: d.data().title, link: d.data().link }));
};

export const getOurWorkPhotos = async () => {
  const q = query(collection(db, 'ourwork_photos'), orderBy('order', 'asc'));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ Image: d.data().Image, Title: d.data().Title }));
};

export const getOurWorkVideos = async () => {
  const q = query(collection(db, 'ourwork_videos'), orderBy('order', 'asc'));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ Link: d.data().Link }));
};

export const getInstagramPosts = async () => {
  const q = query(collection(db, 'instagram_posts'), orderBy('order', 'asc'));
  const snap = await getDocs(q);
  return snap.docs.map(d => d.data());
};
